import React from 'react'

import { EChartsOption, SeriesOption, XAXisComponentOption } from 'echarts'
import { LineChart, LineSeriesOption } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent, DatasetComponent } from 'echarts/components'
import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import ReactECharts from 'echarts-for-react'

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  LineChart,
  CanvasRenderer,
])

export interface ChartLineSeries extends Partial<LineSeriesOption> {
  name: string
  data: (number | string)[] | (number | string)[][]
}

export interface LineGraphChartProps {
  title: string
  subTitle: string
  xAxisData: (string | number)[]
  series: ChartLineSeries[]
  className?: string
  showLegend?: boolean | 'auto'
  xAxisType?: 'category' | 'value' | 'time'
  yAxisType?: 'value' | 'log'
  yAxisName?: string
}

export default function LineGraphChart({
  title,
  subTitle,
  xAxisData,
  series,

  showLegend = 'auto',
  xAxisType = 'category',
  yAxisType = 'value',
  yAxisName,
}: LineGraphChartProps) {
  const processedSeries: LineSeriesOption[] = series.map((s) => ({
    type: 'line' as const,
    showSymbol: false,
    smooth: false,
    ...s,
  }))

  let legendVisible: boolean
  if (showLegend === 'auto') {
    legendVisible = processedSeries.length > 1
  } else {
    legendVisible = showLegend
  }

  let xAxisFinalConfig: XAXisComponentOption

  if (xAxisType === 'category') {
    const categoryAxisConfig: XAXisComponentOption = {
      type: 'category',
      data: xAxisData || [],
    }

    xAxisFinalConfig = categoryAxisConfig
  } else {
    const otherAxisConfig: XAXisComponentOption = {
      type: xAxisType,
    }
    xAxisFinalConfig = otherAxisConfig
  }

  const defaultOptions: EChartsOption = {
    title: {
      text: title,
      subtext: subTitle,
      left: '0',
      textStyle: {
        fontSize: 18,
        fontWeight: 'bold',
      },
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      show: legendVisible,
      bottom: 10,
      type: 'scroll',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: legendVisible ? '10%' : '3%',
      containLabel: true,
    },
    xAxis: xAxisFinalConfig,
    yAxis: [
      {
        type: yAxisType,
        name: yAxisName,
      },
    ],
    series: processedSeries as SeriesOption[],
    // color: [COLORS WILL GO HERE],
  }

  return <ReactECharts option={defaultOptions} style={{ height: '400px' }} />
}
